import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import store from '@Store';
import StructureModel from '@Components/Results/structure/structure-model.service';
import StructureZoomService from '@Services/StructureZoom';
import Structure from '@Components/Results/structure/Structure';
import { openMultiStepReactionDialogForSingleReaction } from '@Pages/RetroSynthesis/MultiStepReactionDialog/actions';
import ReactionViewConnector from '@Components/Results/reactions/ReactionViewConnector';

function ReactionViewItem({
  zoom,
  isFirst,
  isProduct,
  displayTransferTo,
  metadata,
  structure,
  structureTitle,
  showToolbar,
  isLast,
  trailingArrow,
  reactionId,
}) {
  const zoomClasses = StructureZoomService.getZoomClasses('reactions') || [];
  const zoomClass = zoomClasses?.[zoom];
  const detailsId = get(structure, 'details.id');
  const molImagePath = get(structure, 'molImage.path');
  const schemeLoading = useRef(false);

  const goToReactionScheme = () => {
    if (!schemeLoading.current) {
      schemeLoading.current = true;
      store.dispatch(
        openMultiStepReactionDialogForSingleReaction({
          reactionId,
          databaseId: metadata?.databaseId,
          onClose: () => {
            schemeLoading.current = false;
          },
        })
      );
    }
  };

  return (
    <span className={`reactions-item-wrapper u-els-padding-left${isProduct || !isFirst ? ' reactions-item-wrapper--with-connector' : ''} `}>
      {!isFirst ? <ReactionViewConnector icon="plus" /> : null}
      {isProduct && isFirst ? (
        <ReactionViewConnector icon="arrow" displayTransferTo={displayTransferTo} transferToClick={goToReactionScheme} />
      ) : null}
      {isProduct || detailsId || molImagePath ? (
        <Structure
          metadata={metadata}
          structure={structure}
          title={structureTitle}
          zoom={zoom}
          showToolbar={showToolbar}
          className={`substances-item-wrapper substances-item-wrapper--${isProduct ? 'product' : 'reactant'} ${zoomClass}`}
        />
      ) : null}
      {trailingArrow && isLast ? <ReactionViewConnector icon="arrow" /> : null}
    </span>
  );
}

ReactionViewItem.defaultProps = {
  displayTransferTo: false,
};

ReactionViewItem.propTypes = {
  structure: PropTypes.instanceOf(StructureModel).isRequired,
  isProduct: PropTypes.bool,
  trailingArrow: PropTypes.bool,
  metadata: PropTypes.object,
  structureTitle: PropTypes.string,
  zoom: PropTypes.number,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  showToolbar: PropTypes.bool,
  reactionId: PropTypes.string.isRequired,
  displayTransferTo: PropTypes.bool,
};

export default ReactionViewItem;
